module.exports = __webpack_public_path__ + "static/img1-b2e98f48b088610d9f88c1901b21d3c9.png";